import * as React from "react"
import * as SwitchPrimitive from "@radix-ui/react-switch"

import { cn } from "@/lib/utils"

function Switch({
  className,
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        // Track
        "peer inline-flex h-6 w-11 shrink-0 items-center rounded-full p-0.5 transition-all outline-none",
        // Colors and borders for states
        "data-[state=checked]:bg-primary data-[state=unchecked]:bg-muted border border-input",
        // Focus ring
        "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
        // Disabled
        "disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          // Knob
          "pointer-events-none block h-5 w-5 rounded-full bg-white dark:bg-card shadow-sm ring-0 transition-transform",
          // Positions
          "data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0"
        )}
      />
    </SwitchPrimitive.Root>
  )
}

export { Switch }
